import type { ComponentChildren } from "preact";

// The sheet's title row (mockup ux/06 `.sh`): heading, an optional dim detail,
// any controls, ×.
export function SheetHead({
  title,
  dim,
  children,
  onClose,
}: {
  title: string;
  dim?: string | null;
  children?: ComponentChildren;
  onClose: () => void;
}) {
  return (
    <div class="sh">
      <h2>{title}</h2>
      {dim && <span class="dim">{dim}</span>}
      {children}
      <button type="button" class="x" onClick={onClose} aria-label="Close">
        ✕
      </button>
    </div>
  );
}
